import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import ChatRequestsLayer from "./ChatRequestsLayer";


const ChatRequestsPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                {/* Breadcrumb */}
                <Breadcrumb title="Components / Company Categories" />

                {/* CompanyCategoryLayer */}
                <ChatRequestsLayer />

            </MasterLayout>
        </>
    );
};

export default ChatRequestsPage;
